import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Youtube, ChevronDown } from 'lucide-react';
import Logo from '../assets/images/logo/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'HOME' },
    { path: '/about', label: 'ABOUT US' },
    {
      label: 'OUR TREATMENT',
      dropdown: [
        { path: '/treatments/laser-kidney-stone', label: 'Laser Kidney Stone' },
        { path: '/treatments/laparoscopic-urology', label: 'Laparoscopic Urology' },
        { path: '/treatments/hemodialysis-av-fistula', label: 'Hemodialysis & AV Fistula Creation' },
        { path: '/treatments/endourology', label: 'Endourology Treatment' },
        { path: '/treatments/prostate-enlargement', label: 'Prostate Enlargement' },
        { path: '/treatments/urologic-oncology', label: 'Urologic Oncology' },
        { path: '/treatments/andrology', label: 'Andrology' },
        { path: '/treatments/female-urology', label: 'Female Urology' },
        { path: '/treatments/pediatric-urology', label: 'Pediatric Urology' },
      ],
    },
    { path: '/gallery', label: 'GALLERY' },
    { path: '/contact', label: 'CONTACT US' },  
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* Top Bar - Blue */}
      <div className="bg-primary text-white py-2 hidden lg:block shadow-glow">
        <div className="max-w-7xl mx-auto px-8 flex justify-between items-center text-xs font-medium">

          {/* Left Side: Social Icons */}
          <div className="flex items-center gap-4">
            <a href="https://www.facebook.com/people/Dr-SN-Chaurasia-Urologist/61568803236262/" target="_blank" className="hover:text-blue-200 transition-colors">
              <Facebook size={14} />
            </a>
            <a href="https://www.instagram.com/drsachitanand/" target="_blank" className="hover:text-blue-200 transition-colors">
              <Instagram size={14} />
            </a>
            <a href="https://www.linkedin.com/in/sachitanand-chaurasia-19655a281/" target="_blank" className="hover:text-blue-200 transition-colors">
              <Linkedin size={14} />
            </a>
          </div>

          {/* Right Side: Contact Info */}
          <div className="flex items-center gap-6">
            <a href="tel:+9177749 56489" className="flex items-center gap-1">
              <Phone size={14} /> +91-77749 56489
            </a>
            <a href="mailto:drsachiturologist@gmail.com" className="flex items-center gap-1 border-l border-white/30 pl-4">
              <Mail size={14} /> drsachiturologist@gmail.com
            </a>
            <span className="flex items-center gap-1 border-l border-white/30 pl-4">
              <MapPin size={14} /> BBMH Hospital, RC Vyas Colony, Bhilwara, Rajasthan
            </span>
          </div>

        </div>
      </div>
      {/* Main Navigation */}
      <div className="bg-white shadow-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo Section */}
            <Link to="/" className="flex items-center gap-3">
              <img src={Logo} className="h-16" />
              <div>
                <h1 className="font-bold text-primary text-lg leading-tight">
                  Dr. Sachitanand Chaurasia
                </h1>
                <p className="text-xs text-slate-500">Urologist - Andrologist & Kidney Transplant Surgeon</p>
              </div>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link, index) => (
                <div key={index} className="relative group">

                  {/* Normal Link */}
                  {!link.dropdown ? (
                    <Link
                      to={link.path}
                      className="text-gray-700 hover:text-[#0099ca] text-sm font-bold transition-colors"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <>
                      {/* Dropdown Button */}
                      <span className="flex items-center gap-1 text-gray-700 hover:text-[#0099ca] text-sm font-bold cursor-pointer">
                        {link.label}
                        <ChevronDown
                          size={16}
                          className="transition-transform duration-300 group-hover:rotate-180"
                        />
                      </span>

                      {/* Dropdown Menu */}
                      <div className="absolute left-0 top-full mt-3 w-56 bg-white shadow-xl rounded-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                        {link.dropdown.map((item, i) => (
                          <Link
                            key={i}
                            to={item.path}
                            className="block px-5 py-3 text-sm text-gray-700 hover:bg-primary hover:text-white rounded-lg transition"
                          >
                            {item.label}
                          </Link>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              ))}

              <Link
                to="/#appointment"
                className="bg-primary text-white px-6 py-3 rounded-xl font-bold"
              >
                Book Appointment
              </Link>
            </nav>

            {/* Mobile Toggle */}
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="lg:hidden p-2 text-gray-600">
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
            {/* RIGHT DRAWER OVERLAY */}
            <div
              className={`fixed inset-0 bg-black/40 z-40 transition-opacity duration-300 ${isMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
                }`}
              onClick={() => setIsMenuOpen(false)}
            ></div>

            {/* RIGHT DRAWER MENU */}
            <div
              className={`fixed top-0 right-0 h-full w-[300px] bg-white z-50 shadow-2xl transform transition-transform duration-300 ${isMenuOpen ? "translate-x-0" : "translate-x-full"
                }`}
            >
              {/* header */}
              <div className="flex items-center justify-between px-5 py-4 border-b">
                <h2 className="font-bold text-primary text-lg">Menu</h2>
                <button onClick={() => setIsMenuOpen(false)}>
                  <X size={26} />
                </button>
              </div>

              {/* links */}
              <div className="p-5 space-y-4 overflow-y-auto h-full">

                {navLinks.map((link, index) => (
                  <div key={index}>

                    {!link.dropdown ? (
                      <Link
                        to={link.path}
                        onClick={() => setIsMenuOpen(false)}
                        className="block text-gray-700 font-semibold py-2 border-b"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <div>
                        <p className="font-bold text-primary mt-3 mb-2">
                          {link.label}
                        </p>

                        <div className="ml-3 space-y-2">
                          {link.dropdown.map((item, i) => (
                            <Link
                              key={i}
                              to={item.path}
                              onClick={() => setIsMenuOpen(false)}
                              className="block text-gray-600 py-1"
                            >
                              • {item.label}
                            </Link>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                {/* appointment button */}
                <Link
                  to="/#appointment"
                  onClick={() => setIsMenuOpen(false)}
                  className="block text-center bg-primary text-white py-3 rounded-xl font-bold mt-6"
                >
                  Book Appointment
                </Link>

              </div>
            </div>


          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;